// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlibabaOutlinedSvg from "@ant-design/icons-svg/es/asn/AlibabaOutlined";
import AntdIcon from '../components/AntdIcon';

var AlibabaOutlined = function AlibabaOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlibabaOutlinedSvg
  }));
};

AlibabaOutlined.displayName = 'AlibabaOutlined';
export default React.forwardRef(AlibabaOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AlibabaOutlined.js
// module id = 535
// module chunks = 0